import { Card } from "../../models/card";
export class Golem extends Card {
    constructor() {
        super(...arguments);
        this.cooldown = 15000;
    }
}
Golem.displayName = "Golem";
Golem.artUrl = "./assets/cards/golem.jpg";
Golem.requirements = {
    validate: (card) => {
        return !!card.owner;
    },
    description: "Place next to a deck",
};
Golem.effect = {
    callback: () => { },
    description: "Consume a Rock and play a card every 15 seconds",
    needsFeedback: true,
};
